/**
 * Remove all child nodes from an element - https://stackoverflow.com/questions/3955229/remove-all-child-elements-of-a-dom-node-in-javascript
 * @param  HTMLElement element Required - the element that all child nodes need to be removed from
 */
module.exports = (element) => {
    while (element.firstChild) {
        element.removeChild(element.lastChild);
    }
};